import React, { useState } from 'react';
import { Box } from 'bloomer/lib/elements/Box';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Select } from 'bloomer/lib/elements/Form/Select';
import { Button } from 'bloomer/lib/elements/Button';
import styled from 'styled-components';
import { Content } from 'bloomer/lib/elements/Content';
import Conditional from './Conditional';
import api from '../util/api';
import { confirmSuccessAfter, confirmPopupBefore } from '../util/helperFunctions';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import Spacer from '../elements/Spacer';
import { Icon } from 'bloomer/lib/elements/Icon';
import { Input } from 'bloomer';

interface PropTypes {
  location: ILocation;
  i: number;
  refresh: () => void;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FlexedColumns = styled(({ isChange, ...props }) => <Columns {...props} />)`
  ${({ isChange }) => (isChange ? 'border: orange 2px solid;' : '')}
  h2.title,div.content {
    margin-bottom: 0;
  }
`;

const LocationCell = ({ location, i, refresh }: PropTypes) => {
  const [bioSecurityLevel, setBioSecurityLevel] = useState(location.bioSecurity);
  const [name, setName] = useState(location.name);

  const hasBioSecurityChanged = bioSecurityLevel !== location.bioSecurity;
  const hasNameChanged = name !== location.name;

  const isChange = hasBioSecurityChanged || hasNameChanged;

  const handleBioSecurityChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const value = (e.target as HTMLSelectElement).value;
    const int = parseInt(value, 10) as 1 | 2 | 3;
    if (isNaN(int)) {
      return;
    }
    setBioSecurityLevel(int);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await confirmSuccessAfter(`Location ${location.name} updated successfully!`, () =>
      api.locations.patch(location._id, {
        name,
        bioSecurity: bioSecurityLevel,
      }),
    );
    refresh();
  };

  const handleDelete = async () => {
    await confirmPopupBefore(
      'Are you sure you want to delete this location? All animals currently set to this location will now be set to "unknown".',
      async () => {
        await confirmSuccessAfter(`Location ${location.name} successfully deleted!`, () =>
          api.locations.delete(location._id),
        );
        refresh();
      },
    );
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <FlexedColumns isVCentered={true} isChange={isChange}>
          <Column isSize="narrow">{i + 1}.</Column>
          <Column>
            <Content>
              <Field>
                <Label isSize="small" htmlFor="locationName">
                  Location Name:
                </Label>
                <Control>
                  <Input
                    isSize="small"
                    // tslint:disable-next-line:jsx-no-lambda
                    onChange={(e: React.FormEvent<HTMLInputElement>) => setName((e.target as HTMLInputElement).value)}
                    value={name}
                    id="locationName"
                    required={true}
                  />
                </Control>
              </Field>
              <Conditional check={isChange}>
                <p>**Please click save to finalize your updates</p>
              </Conditional>
            </Content>
          </Column>
          <Column>
            <Field>
              <Label isSize="small" htmlFor="animalType">
                Bio Security Level:
              </Label>
              <Control>
                <Select
                  isSize="small"
                  // tslint:disable-next-line:jsx-no-lambda
                  onChange={handleBioSecurityChange}
                  value={bioSecurityLevel}
                  id="bioSecurity"
                  required={true}
                >
                  <option value=""> - </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </Select>
              </Control>
            </Field>
          </Column>
          <Column>
            <Field isGrouped={true}>
              <Spacer>
                <Button disabled={!isChange} type="submit" isColor="primary">
                  <Icon className="fa fa-floppy-o" />
                  <Spacer>Save</Spacer>
                </Button>
              </Spacer>
              <Spacer>
                <Button type="button" isColor="danger" onClick={handleDelete}>
                  <Icon className="fa fa-trash" />
                  <Spacer>Delete</Spacer>
                </Button>
              </Spacer>
            </Field>
          </Column>
        </FlexedColumns>
      </form>
    </Box>
  );
};

export default LocationCell;
